// jQuery
jQuery(function ($) {
  // ハンバーガーメニュー
  $('.gnavBtn').on('click', function () {
    $(this).toggleClass('is-open');
    $('.gnav').toggleClass('is-open');
    var expanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !expanded);
    var label = $(this).attr('aria-label') === 'メニューを開く' ? 'メニューを閉じる' : 'メニューを開く';
    $(this).attr('aria-label', label);
  });
  $('.gnav a').on('click', function () {
    $('.gnav').removeClass('is-open');
    $('.gnavBtn').removeClass('is-open');
    $('.gnavBtn').attr('aria-expanded', 'false');
    $('.gnavBtn').attr('aria-label', 'メニューを開く');
  });


  // フェードイン
  $(window).on('load scroll', function () {

    var box = $('.fadeIn');
    var animated = 'is-show';

    $('.fadeIn').each(function () {

      var boxOffset = $(this).offset().top;
      var scrollPos = $(window).scrollTop();
      var wh = $(window).height();

      if (scrollPos > boxOffset - wh + 100) {
        $(this).addClass(animated);
      }
    });
  });


  // ページトップ
  var PageTop = $('.footerPageTop');

  PageTop.click(function () {
    $('body,html').animate({
      scrollTop: 0
    },
      500,);
    return false;
  });


  // contact　メールアドレスコピー
  const copyText = "info@pm-institute.co.jp";

  $(".contact-btn").on("click", function () {
    const $btn = $(this);

    navigator.clipboard.writeText(copyText).then(function () {
      $btn.addClass("is-copied");

      setTimeout(function () {
        $btn.removeClass("is-copied");
      }, 2000);
    });
  });
});